import script from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTabs.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeTabs.vue?vue&type=style&index=0&id=10082e15&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10082e15"]])

export default __exports__